// Shared numeric "limit" input used by every step that caps how many
// items it processes. Empty/0 means "no limit" — the server treats both
// the same (limit.to_i.positive?).
export default function LimitField({ config, setConfig }) {
  return (
    <label className="block">
      <span className="text-xs font-medium text-muted-foreground">Limit</span>
      <input type="number"
             min="0"
             placeholder="All"
             value={config.limit ?? ""}
             onChange={e => setConfig({ ...config, limit: e.target.value === "" ? null : Number(e.target.value) })}
             className="mt-1 w-full h-9 px-2 rounded-md border border-border bg-background text-sm" />
      <p className="text-[11px] text-muted-foreground mt-1">
        Max records to process. Leave blank for no limit.
      </p>
    </label>
  )
}
